import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from "yup";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import hoastLogo from "../../../assets/images/HOAST-LOGO_2 1.png"
import { LuEye, LuEyeClosed, LuArrowLeft } from "react-icons/lu";
import { useState } from 'react';
import EllipsisLoader from '../../../base_component/EllipsisLoader/EllipsisLoader';
import { forgotPassword } from '../../../service/ApiServices';
import toast from 'react-hot-toast';

export default function NewPassword() {
    const navigate = useNavigate()
    const location = useLocation()
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const forgotPasswordValue = location?.state?.forgotPasswordValue || '';

    const initialValues = {
        newPassword: "",
        confirmPassword: "",
    };

    const validationSchema = Yup.object({
        newPassword: Yup.string()
            .min(8, "Minimum 8 characters")
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, "Must include uppercase, lowercase, and a number")
            .required("New Password Required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
            .required("Confirm Password Required"),
    });

    const onSubmit = async (values) => {
        setIsLoading(true);

        const params = {
            email: forgotPasswordValue,
            new_password: values.confirmPassword
        };

        forgotPassword(params)
            .then((res) => {
                const message = res?.data?.message;
                const status = res?.data?.status;
                
                if (status === 1) {
                    setIsLoading(false);
                    toast.success(message);
                    navigate("/login");
                } else {
                    setIsLoading(false);
                    toast.error(message);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                const message = err?.response?.data?.message || 'Failed to update password';
                toast.error(message);
            });
    };

    return (
        <div className="h-screen flex flex-col items-center justify-center px-4">
            <div className="flex justify-center mb-4">
                <img src={hoastLogo} alt="Logo" className="md:h-36 h-24" />
            </div>
            <div className="bg-white md:p-8 p-5 rounded-xl shadow-md w-full max-w-xl">
                <h2 className="md:text-2xl text-xl font-semibold text-start mb-1">New password</h2>
                <p className="text-start text-sm text-gray-500 mb-6">Don't reuse your previous password.</p>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {({ values }) => (
                        <Form className="space-y-4">
                            <div className="relative">
                                <label htmlFor="newPassword" className="block text-sm font-medium text-[#667085]">
                                    New Password
                                </label>
                                <Field
                                    type={showNewPassword ? "text" : "password"}
                                    name="newPassword"
                                    placeholder="Enter"
                                    disabled={isLoading}
                                    className="mt-1 block text-sn w-full px-4 py-3 border-2 border-gray-300 rounded-xl shadow-sm focus:border-2 focus:outline-none focus:border-[#24B565] disabled:opacity-50"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    className="absolute right-4 top-10 text-gray-500"
                                    tabIndex={-1}
                                >
                                    {showNewPassword ? <LuEye size={20} /> : <LuEyeClosed size={20} />}
                                </button>
                                <ErrorMessage name="newPassword" component="div" className="text-red-500 text-xs mt-1" />
                            </div>

                            <div className="relative">
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-[#667085]">
                                    Confirm New Password
                                </label>
                                <Field
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    placeholder="Enter"
                                    disabled={isLoading}
                                    className="mt-1 block text-sn w-full px-4 py-3 border-2 border-gray-300 rounded-xl shadow-sm focus:border-2 focus:outline-none focus:border-[#24B565] disabled:opacity-50"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    className="absolute right-4 top-10 text-gray-500"
                                    tabIndex={-1}
                                >
                                    {showConfirmPassword ? <LuEye size={20} /> : <LuEyeClosed size={20} />}
                                </button>
                                <ErrorMessage name="confirmPassword" component="div" className="text-red-500 text-xs mt-1" />
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading || !values.newPassword || !values.confirmPassword}
                                className={`w-full h-[52px] rounded-xl transition duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed ${values.newPassword && values.confirmPassword
                                    ? 'bg-black text-white'
                                    : 'bg-[#F0F1F3] text-gray-500'
                                    }`}
                            >
                                {isLoading ? (
                                    <EllipsisLoader color={values.newPassword && values.confirmPassword ? "white" : "red"} />
                                ) : (
                                    'Continue'
                                )}
                            </button>
                        </Form>
                    )}
                </Formik>

                <div className="mt-6 text-center">
                    <Link
                        to="/login"
                        className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
                    >
                        <LuArrowLeft size={16} className="mr-1" />
                        Go back
                    </Link>
                </div>
            </div>
        </div>
    )
}
